module.exports = __webpack_public_path__ + "static/media/avatar-vendor-default-big.665db023.png";